import ArrowLink from '../components/ArrowLink.jsx';
import LotusMark from '../components/LotusMark.jsx';
import ResponsiveImage from '../components/ResponsiveImage.jsx';
import SectionHeader from '../components/SectionHeader.jsx';
import { eventDateRange, pillars, wellnessDays } from '../content.js';

export default function Home() {
  return (
    <>
      <section className="home-hero">
        <ResponsiveImage
          className="home-hero__image"
          src="/assets/hero-community.jpg"
          alt="An intergenerational community gathering in San Francisco"
          eager
          sizes="100vw"
        />
        <div className="home-hero__veil" />
        <div className="home-hero__content shell reveal">
          <a className="location-link" href="/sf"><span aria-hidden="true">⌖</span> San Francisco <i /> More cities coming</a>
          <h1>Together, we build<br />{' '}healthier communities.</h1>
          <div className="flourish"><span /><LotusMark /><span /></div>
          <p>A community-powered movement advancing wellness, education, culture, sustainability, humanitarian action, and economic opportunity - beginning in San Francisco and extending to Cambodia.</p>
          <div className="button-row">
            <a className="button button--gold" href="/contact">Join the movement <span aria-hidden="true">→</span></a>
            <ArrowLink href="/sf">Explore San Francisco</ArrowLink>
          </div>
        </div>
      </section>

      <section className="mission-band section-pad">
        <div className="shell mission-band__grid">
          <div className="mission-band__lead reveal">
            <p className="overline">Our mission</p>
            <h2>Five days. One purpose.<br /><em>Limitless transformation.</em></h2>
          </div>
          <div className="mission-band__copy reveal reveal--delay">
            <p>The K.E.E.N. Movement brings together businesses, healthcare providers, educators, nonprofits, government agencies, and volunteers around shared purpose - strengthening communities through seven connected pillars.</p>
            <ArrowLink href="/our-story">Learn about the movement</ArrowLink>
          </div>
        </div>
      </section>

      <section className="pillar-rail" aria-label="The Seven Pillars">
        <div className="shell pillar-rail__inner">
          {pillars.map((pillar) => (
            <a key={pillar.id} href={`/pillars#${pillar.id}`}>
              <span>{pillar.number}</span>
              <strong>{pillar.name}</strong>
              <small>{pillar.tagline.split('.')[0]}.</small>
            </a>
          ))}
        </div>
      </section>

      <section className="city-directory section-pad">
        <div className="shell">
          <SectionHeader label="Find your city" title="Local roots. Shared purpose." body="Each chapter is built around the needs, strengths, and cultural life of its city. San Francisco is where the movement begins." />
          <div className="city-directory__grid">
            <a className="city-card city-card--live reveal" href="/sf">
              <div>
                <p>Active chapter</p>
                <h3>San Francisco</h3>
                <span>Transformational Wellness Week • Project Cambodia • Community partnerships</span>
              </div>
              <b>Visit /sf <span aria-hidden="true">→</span></b>
            </a>
            <div className="city-card city-card--future reveal reveal--delay">
              <div>
                <p>Growing with intention</p>
                <h3>Your city could be next.</h3>
                <span>Future chapters will have their own local page, program, partners, and community story.</span>
              </div>
              <ArrowLink href="/contact">Start a city conversation</ArrowLink>
            </div>
          </div>
        </div>
      </section>

      <section className="week-preview section-pad section-dark">
        <div className="shell">
          <SectionHeader light label={`Transformational Wellness Week • ${eventDateRange}`} title="Five days. One community. Lasting impact." body="An immersive week of wellness, learning, connection, and celebration - designed to uplift lives and strengthen communities." />
          <ol className="day-line">
            {wellnessDays.map((day) => (
              <li key={day.slug}>
                <span>{day.number}</span>
                <h3>{day.name}</h3>
                <p>{day.theme}</p>
              </li>
            ))}
          </ol>
          <ArrowLink href="/wellness-week" inverse>View the full week</ArrowLink>
        </div>
      </section>

      <section className="split-feature split-feature--cambodia section-pad">
        <div className="shell split-feature__grid">
          <figure className="split-feature__media reveal">
            <ResponsiveImage
              src="/assets/project-cambodia.jpg"
              alt="A Cambodian community learning and wellness gathering"
              sizes="(max-width: 900px) 100vw, 48vw"
            />
          </figure>
          <div className="split-feature__copy reveal reveal--delay">
            <p className="overline">Project Cambodia</p>
            <h2>One community. Two worlds. Limitless possibility.</h2>
            <p>From the heart of San Francisco to the heart of Cambodia, the K.E.E.N. Movement bridges cultures, inspires collaboration, and creates lasting impact across borders.</p>
            <ul className="inline-points"><li>Wellness</li><li>Education</li><li>Food security</li><li>Community development</li></ul>
            <ArrowLink href="/project-cambodia">Explore Project Cambodia</ArrowLink>
          </div>
        </div>
      </section>

      <section className="partner-cta section-pad">
        <div className="shell partner-cta__inner">
          <LotusMark />
          <p className="overline">Partner with purpose</p>
          <h2>You do not simply support change.<br /><em>You help create it.</em></h2>
          <p>Build healthier communities, expand opportunity, and leave a legacy that lasts.</p>
          <div className="button-row button-row--center">
            <a className="button button--gold" href="/partner">Explore partnerships <span aria-hidden="true">→</span></a>
            <a className="button button--outline-light" href="/assets/keen-transformational-wellness-deck.pdf">Download the deck</a>
          </div>
        </div>
      </section>
    </>
  );
}
